import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { CopyAndEditAttachesExecutorModal } from './CopyAndEditAttachesExecutorModal';
import { ICopyAndEditAttachesExecutorProps } from './ICopyAndEditAttachesExecutorProps';

export class CopyAndEditAttachesExecutor extends DocBaseActionExecutor {
    private _modalProps?: ICopyAndEditAttachesExecutorProps;

    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: objId ?? '',
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'xl',
            actionKey: action.key ?? '',
            displayName: action.displayName ?? '',
            completeHandler: completeHandler,
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <CopyAndEditAttachesExecutorModal {...this._modalProps} /> : <div />;
    };
}
